import type { MarketIdentifiers } from '$lib/types/market';
import type { IBuilderReturnData } from '../types';
import { closeFullLimitTradeSmartContract } from '../connectors/close';
import { cancelLimitOrder } from '../connectors/orders';

export const buildCloseFullLimitTradeSmartContract = async (
	marketIdentifier: MarketIdentifiers,
	priceImpact: string,
	isUpper: boolean,
	triggerPrice: string,
	limitPrice: string,
	expiry: string
): Promise<IBuilderReturnData> => {
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];

	const closeFullLimitTradeSmartContractCallData = await closeFullLimitTradeSmartContract(
		marketIdentifier,
		priceImpact,
		isUpper,
		triggerPrice,
		limitPrice,
		expiry
	);

	targetArray.push(closeFullLimitTradeSmartContractCallData._target);
	callDataArray.push(closeFullLimitTradeSmartContractCallData._callData);

	return {
		_targetArray: targetArray,
		_callDataArray: callDataArray
	};
};

export const buildCancelLimitTradeSmartContract = async (
	orderId: string
): Promise<IBuilderReturnData> => {
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];

	const cancelLimitTradeSmartContract = await cancelLimitOrder(orderId);

	targetArray.push(cancelLimitTradeSmartContract._target);
	callDataArray.push(cancelLimitTradeSmartContract._callData);

	return {
		_targetArray: targetArray,
		_callDataArray: callDataArray
	};
};
